
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256 0c141.384 0 255.998 114.614 255.998 255.998C511.998 397.383 397.384 512 256 512S.002 397.383.002 255.998C.002 114.614 114.616 0 256 0zm-.007 44.826c116.63 0 211.184 94.549 211.184 211.18 0 116.635-94.554 211.184-211.184 211.184-116.634 0-211.184-94.549-211.184-211.184 0-116.631 94.549-211.18 211.184-211.18z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#FFF","d":"M256.226 499.725c134.941 0 244.333-109.392 244.333-244.333-1.44-18.538-25.267-12.629-20.657.009 0 123.538-100.147 223.685-223.685 223.685-13.016.459-14.315 20.105.009 20.639z"}})])
          )
        }
      }
    